// Define my API base URL
const BASE_URL = 'https://test.creative-its.com/back/api/section';

// Function to fetch all sections from the backend
export const fetchSections = async (token) => {
    try {
        const response = await fetch(`${BASE_URL}/index`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error('Failed to fetch sections');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching sections:', error);
        throw error;
    }
};

// Function to create a new section
export const createSection = async (token, sectionData) => {
    try {
        const response = await fetch(`${BASE_URL}/create`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(sectionData),
        });
        if (!response.ok) {
            throw new Error('Failed to create section');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating section:', error);
        throw error;
    }
};

// Function to update an existing section by ID
export const updateSection = async (token, sectionId, sectionData) => {
    try {
        const response = await fetch(`${BASE_URL}/update_section/${sectionId}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(sectionData),
        });
        if (!response.ok) {
            throw new Error('Failed to update section');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating section:', error);
        throw error;
    }
};

// Function to delete a section by ID
export const deleteSection = async (token, sectionId) => {
    try {
        const response = await fetch(`${BASE_URL}/delete_section/${sectionId}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (!response.ok) {
            throw new Error('Failed to delete section');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error deleting section:', error);
        throw error;
    }
};
// Function to fetch all groups
export const fetchGroups = async (token) => {
    try {
        const response = await fetch(`${BASE_URL}/groups?token=${token}`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error('Failed to fetch groups');
        }
        const data = await response.json(); // Parse JSON response
        const groupNames = Object.values(data); // Extract group names assuming they are stored as values in the object
        return groupNames;
    } catch (error) {
        console.error('Error fetching groups:', error);
        throw error;
    }
};
